import { useState } from "react";
import { motion } from "framer-motion";
import { Target, BarChart3, HeartHandshake, Zap } from "lucide-react";
import { Reveal } from "@/components/motion";

export const PRINCIPI = [
  { icon: Target, title: "Visione integrata", desc: "Ogni area del tuo business dialoga con le altre, non lavora in compartimenti stagni." },
  { icon: BarChart3, title: "Risultati concreti", desc: "Misuriamo quello che facciamo: numeri, non solo intenzioni." },
  { icon: HeartHandshake, title: "Vicinanza umana", desc: "Un referente che conosce davvero la tua azienda, non un ticket in una coda." },
  { icon: Zap, title: "Reattività", desc: "Rispondiamo entro 24 ore. Le decisioni aziendali non aspettano." },
];

const R = 100;
const GAP = 0.035;
const arc = (i) => {
  const a0 = -Math.PI / 2 + (i * Math.PI) / 2 + GAP;
  const a1 = -Math.PI / 2 + ((i + 1) * Math.PI) / 2 - GAP;
  const p = (a, r) => `${(120 + r * Math.cos(a)).toFixed(2)} ${(120 + r * Math.sin(a)).toFixed(2)}`;
  return `M ${p(a0, 58)} L ${p(a0, R)} A ${R} ${R} 0 0 1 ${p(a1, R)} L ${p(a1, 58)} A 58 58 0 0 0 ${p(a0, 58)} Z`;
};
const ICON_POS = [[168, 72], [168, 168], [72, 168], [72, 72]];

export const ValuesWheel = () => {
  const [active, setActive] = useState(0);
  const cur = PRINCIPI[active];
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-testid="values-wheel">
      <Reveal className="lg:col-span-6 flex justify-center">
        <svg viewBox="0 0 240 240" className="w-[300px] h-[300px] sm:w-[380px] sm:h-[380px]" role="group" aria-label="I quattro principi">
          <circle cx="120" cy="120" r="112" fill="none" stroke="rgba(0,0,0,0.25)" strokeWidth="1" strokeDasharray="2 4" />
          {PRINCIPI.map((v, i) => {
            const Icon = v.icon;
            const [x, y] = ICON_POS[i];
            const on = i === active;
            return (
              <g
                key={v.title}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className="cursor-pointer"
                data-testid={`wheel-segment-${i}`}
              >
                <motion.path
                  d={arc(i)}
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.15 + i * 0.12, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  style={{ transformOrigin: "120px 120px" }}
                  animate={{ fill: on ? "#000000" : "rgba(0,0,0,0.08)", stroke: on ? "#000000" : "rgba(0,0,0,0.45)" }}
                  strokeWidth="1.2"
                />
                <foreignObject x={x - 14} y={y - 14} width="28" height="28" className="pointer-events-none">
                  <div className={`w-7 h-7 flex items-center justify-center ${on ? "text-[#FACC15]" : "text-black"}`}>
                    <Icon size={20} strokeWidth={1.9} />
                  </div>
                </foreignObject>
              </g>
            );
          })}
          <circle cx="120" cy="120" r="46" fill="#000" />
          <text x="120" y="114" textAnchor="middle" fill="#FACC15" fontSize="11" fontWeight="700" letterSpacing="2" style={{ fontFamily: "Outfit, sans-serif" }}>
            IDEA 360
          </text>
          <text x="120" y="132" textAnchor="middle" fill="#fff" fontSize="9" letterSpacing="1.5" style={{ fontFamily: "Outfit, sans-serif" }}>
            4 PRINCIPI
          </text>
        </svg>
      </Reveal>

      <div className="lg:col-span-6">
        <div className="flex gap-2 mb-8 flex-wrap">
          {PRINCIPI.map((v, i) => (
            <button
              key={v.title}
              type="button"
              onClick={() => setActive(i)}
              className={`text-xs tracking-[0.15em] uppercase px-4 min-w-[48px] min-h-[44px] inline-flex items-center justify-center border transition-colors ${i === active ? "bg-black text-[#FACC15] border-black" : "border-black/40 text-black hover:border-black"}`}
              data-testid={`wheel-tab-${i}`}
            >
              0{i + 1}
            </button>
          ))}
        </div>
        <motion.div key={active} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} data-testid="wheel-detail">
          <p className="text-xs tracking-[0.25em] uppercase text-black/60 mb-3">Principio 0{active + 1}</p>
          <h3 className="text-3xl sm:text-4xl font-bold leading-tight" style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }} data-testid="wheel-title">
            {cur.title}
          </h3>
          <p className="mt-5 text-black/75 text-lg leading-relaxed">{cur.desc}</p>
        </motion.div>
      </div>
    </div>
  );
};

export default ValuesWheel;
